import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseAlerts } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId = 0;
    const cycle = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        timeoutId = window.setTimeout(() => {
          setIndex(prev => (prev + 1) % purchaseAlerts.length);
          cycle();
        }, 9000);
      }, 6000);
    };
    const start = window.setTimeout(cycle, 7000);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(timeoutId);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const alert = purchaseAlerts[index];
  const minutes = 2 + index % 7;
  return <div aria-live="polite" className={`fixed left-3 top-3 z-50 w-[min(21rem,calc(100vw-1.5rem))] rounded-xl border border-arc/40 bg-ink-700 p-3 shadow-2xl transition-[transform,opacity] duration-200 ease-out sm:left-4 sm:top-4 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-3 opacity-0'}`} data-id="element-37" data-mp="1gynhdd0kycjv">
      <div className="flex items-start gap-3" data-id="element-38" data-mp="1aw61m4l48u30">
        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-arc-light" aria-hidden="true" data-id="element-39" data-mp="1axheqv0gbe6s" />
        <div className="min-w-0 flex-1" data-id="element-40" data-mp="n7ddguaqjqiy">
          <p className="text-[13px] font-bold leading-snug text-bone" data-id="element-41" data-mp="i8a796j0re9e">
            {alert.name} ha appena acquistato il Sistema Maestro di Saldatura™
          </p>
          <p className="mt-0.5 text-[11px] font-medium text-mute" data-id="element-42" data-mp="x37zlze643qh">
            {alert.place} · {minutes} minuti fa
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="rounded p-0.5 text-mute transition-colors duration-150 ease-out hover:text-bone focus-visible:outline focus-visible:outline-2 focus-visible:outline-arc" data-id="element-43" data-mp="28jya3upmjhpw">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="2fmv3oz7h5wu5" />
        </button>
      </div>
    </div>;
}